import Vue from 'vue';

export default Vue.extend({
  methods: {
    getRandom: function () {
      return Math.floor(Math.random() * Math.floor(99999));
    }
  }
});
